import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { Sidebar, SidebarItem } from 'apps/home/activityFeed/styles';

export const AnnouncementSidebar = withNamespaces()(
  observer(() => (
    <Sidebar>
      <SidebarItem title>
        <Trans>📢 Announcements</Trans>
      </SidebarItem>
      <SidebarItem last light>
        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://wikifactory.com/+wikifactory/stories/introducing-our-brand-new-file-visualisation-system'
        >
          <Trans>Introducing our brand new File Visualisation system</Trans>
        </a>
      </SidebarItem>
    </Sidebar>
  )),
);
